import { Card, CardContent, CardHeader, CardTitle } from "@/shared/ui/card";
import { Progress } from "@/shared/ui/progress";
import { Users, Cpu, Package, Zap } from "lucide-react";

export function ResourceUtilizationWidget() {
  const resources = [
    { name: "Workforce", value: 87, icon: Users, total: "245 / 280", status: "optimal" },
    { name: "Equipment", value: 92, icon: Cpu, total: "23 / 25 active", status: "optimal" },
    { name: "Materials", value: 68, icon: Package, total: "Stock level", status: "warning" },
    { name: "Energy", value: 78, icon: Zap, total: "845 kW", status: "optimal" },
  ];

  const getStatusColor = (status: string) => {
    switch (status) {
      case "optimal":
        return "text-success";
      case "warning":
        return "text-warning";
      case "critical":
        return "text-destructive";
      default:
        return "text-muted-foreground";
    }
  };

  return (
    <Card className="h-full">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2">
          <Cpu className="h-4 w-4" />
          Resource Utilization
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {resources.map((resource) => (
          <div key={resource.name} className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <resource.icon className={`h-4 w-4 ${getStatusColor(resource.status)}`} />
                <span className="text-sm font-medium">{resource.name}</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-xs text-muted-foreground">{resource.total}</span>
                <span className={`text-sm font-bold ${getStatusColor(resource.status)}`}>
                  {resource.value}%
                </span>
              </div>
            </div>
            <Progress value={resource.value} className="h-2" />
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
